export const SET_LABELS = 'SET_LABELS'
export const SET_ORIGINAL_STATE_LABELS = 'SET_ORIGINAL_STATE_LABELS'
export const SET_LOADING_ON = 'SET_LOADING_ON';
export const SET_LOADING_OFF = 'SET_LOADING_OFF';
export const QRLABEL = 'QRLABEL';
export const SET_RECORD_TRACKING_DATA = 'SET_RECORD_TRACKING_DATA';
